import { Box, Typography } from '@mui/material';
import i18n from 'src/locales/i18n';
import { fDate, fStringToStringDate } from 'src/utils/format_time';
import { formatVariants } from 'src/utils/format_data';
import { ProductCard, ProductViewType } from './product_card';
import { StockTypeBadge } from 'src/components/badge/stock_type_badge';

export const ProductLotCell = ({
  product,
  productViewType = ProductViewType.ROW_SMALL,
  productWidth = '60%',
  alignItems = 'center',
  productAlignItems = 'center',
  titleOnClick = null,
  tooltip = true,
  badge = null,
  option = formatVariants(product?.productVariants),
  bin = product?.rackSlotBarcode,
  lotNumber = product?.lotNumber,
  expirationDt = product?.expirationDt,
  stockType = product?.stockType,
  stockTypeNameLocal = product?.stockTypeNameLocal,
  stockTypeNameEnglish = product?.stockTypeNameEnglish,
}) => {
  const formatExpiration = (value) => {
    if (!value) return null;
    const converted = fStringToStringDate(value);
    if (converted) return converted.slice(0, 10);
    try {
      return fDate(value);
    } catch {
      return value;
    }
  };

  const infoRow = (label, value) => (
    <Typography variant="body_md">
      {label} : {value}
    </Typography>
  );

  return (
    <Box sx={{ display: 'flex', alignItems, width: '100%', gap: 1.5 }}>
      <Box sx={{ flex: productWidth ? `0 0 ${productWidth}` : '0 1 auto', minWidth: 0 }}>
        <ProductCard
          product={product}
          productViewType={productViewType}
          showBarcode
          barcodeIcon
          tooltip={tooltip}
          option={option}
          alignItems={productAlignItems}
          titleOnClick={titleOnClick}
          badge={badge}
        />
      </Box>
      <Box
        sx={{
          flex: productWidth ? '1 1 auto' : '0 0 auto',
          alignSelf: 'stretch',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: 0.25,
        }}
      >
        {bin && infoRow(i18n.t('common:field.bin'), bin)}
        {lotNumber && infoRow(i18n.t('common:field.lot'), lotNumber)}
        {expirationDt && infoRow(i18n.t('common:field.exp'), formatExpiration(expirationDt))}
        {stockType && (
          <StockTypeBadge
            stockType={stockType}
            nameLocal={stockTypeNameLocal}
            nameEnglish={stockTypeNameEnglish}
          />
        )}
      </Box>
    </Box>
  );
};
